import useMutation from "src/hooks/useMutation";

function useBatchCreate() {
  return useMutation({
    path: "/api/v1/batches",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/batches`,
      shouldRevalidate: true,
    },
  });
}

export default useBatchCreate;
